<template>
  <div class="selector">
    <div class="header">数据中心</div>
    <div class="query">
      <a-form-model layout="inline" :colon="false">
        <a-form-model-item>
          <a-radio-group button-style="solid" v-model="form.dateType">
            <a-radio-button value="日">近一天</a-radio-button>
            <a-radio-button value="月">近三天</a-radio-button>
            <a-radio-button value="年">近一周</a-radio-button>
            <a-radio-button value="自定义">自定义</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.dateType === '自定义'">
<!--          <a-range-picker v-model="date" />-->
            <RangePickerField labelWidth="0" v-model="date" :placeholder="['开始时间', '结束时间']"/>
        </a-form-model-item>
      </a-form-model>
    </div>

    <Chart />
  </div>
</template>

<script>
import Chart from "./chart.vue";
import RangePickerField from "@/components/water-affairs-style/field/RangePickerField.vue";
export default {
  components: {
    Chart,RangePickerField
  },

  data() {
    return {
      form: {},
      date: null,
    };
  },
};
</script>
<style lang="less" scoped>
.selector {
  position: fixed;
  top: 11vh;
  left: 17vw;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--default-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #065645;
  & > .header {
    background-color:rgba(0, 0, 0, 0.9);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0 0.5rem 1rem;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1rem;
  }

  .query {
    padding: 2vh 1vw 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table {
    padding: 2vh 1vw;
  }
  .queryInfo{
    display: flex;
    justify-content: space-around;
  }
}

::v-deep .ant-radio-button-wrapper{
  background: #010103!important;
  border: 1px solid #065645!important;
  color: rgb(173 173 173);
}
::v-deep .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before{
  background: #0b4846;
}
::v-deep .ant-radio-button-wrapper:not(:first-child)::before{
  background: #0b4846;
}
::v-deep .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  color: #00ff96;
}
</style>
